module.exports = __webpack_public_path__ + "static/media/Arrow_Next_Step_Orange.88293926.svg";